import { FC, ReactNode } from 'react';
import styles from './ModalHeader.module.scss';

export const ModalHeader: FC<{ children: ReactNode }> = ({ children }) => {
    return <div className={styles.modalHeader}>{children}</div>;
};
